import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const PrivateRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="loading">
        <p>Loading...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    // Remembered so email links (e.g. NCF notifications) land on the intended page after login.
    const returnPath = `${location.pathname}${location.search}`;
    if (returnPath && returnPath !== '/login') {
      sessionStorage.setItem('postLoginRedirect', returnPath);
    }
    return <Navigate to="/login" />;
  }

  return children;
};

export default PrivateRoute;
